module.exports = __webpack_public_path__ + "static/media/img_13.ffa2a25f.png";